import { OrderFormValue } from './index';
var OrderFormAdditional = /*@__PURE__*/ (function () {
    function OrderFormAdditional() {
    }
    OrderFormAdditional.prototype.getAgb = function () {
        return this.additional_agb;
    };
    OrderFormAdditional.prototype.setAgb = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(4)
            .setMax(5)
            .setMand('Y')
            .setType('bool')
            .setExpectedValue(true);
        this.additional_agb = formValue;
        return this;
    };
    OrderFormAdditional.prototype.getCredit = function () {
        return this.additional_credit;
    };
    OrderFormAdditional.prototype.setCredit = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(4)
            .setMax(5)
            .setMand('Y')
            .setType('bool')
            .setExpectedValue(true);
        this.additional_credit = formValue;
        return this;
    };
    OrderFormAdditional.prototype.getRV190011 = function () {
        return this.additional_RV190011;
    };
    OrderFormAdditional.prototype.setRV190011 = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(4)
            .setMax(5)
            .setMand('Y')
            .setType('bool')
            .setExpectedValue(null);
        this.additional_RV190011 = formValue;
        return this;
    };
    OrderFormAdditional.prototype.getDataAgreement = function () {
        return this.additional_beratung_daten;
    };
    OrderFormAdditional.prototype.setDataAgreement = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(2)
            .setMax(3)
            .setMand('N')
            .setType('selection[Ja|Off]');
        this.additional_beratung_daten = formValue;
        return this;
    };
    OrderFormAdditional.prototype.getOfferAgreement = function () {
        return this.additional_beratung_angebote;
    };
    OrderFormAdditional.prototype.setOfferAgreement = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(2)
            .setMax(3)
            .setMand('N')
            .setType('selection[Ja|Off]');
        this.additional_beratung_angebote = formValue;
        return this;
    };
    OrderFormAdditional.prototype.getRvNr = function () {
        return this.additional_rv_nr;
    };
    OrderFormAdditional.prototype.setRvNr = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(1)
            .setMax(10)
            .setMand('Y')
            .setType('string|numeric');
        this.additional_rv_nr = formValue;
        return this;
    };
    return OrderFormAdditional;
}());
export { OrderFormAdditional };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.form-additional.ts
// module id = null
// module chunks = 